<template><div><h1 id="artikel-lieferanten" tabindex="-1"><a class="header-anchor" href="#artikel-lieferanten"><span>Artikel (Lieferanten-)</span></a></h1>
<p>Artikel (-Lieferanten) — Verwaltet lieferantenspezifische Artikeldaten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Im Lieferantenartikel werden alle Abmachungen und Informationen gepflegt, die artikelspezifisch zwischen dem Einkauf und einem bestimmten Lieferanten vereinbart werden können. Es ist möglich, für den selben Artikel mehrere Lieferanten mit unterschiedlichen Lieferbedingungen zu berücksichtigen. Die in diesem Fenster gepflegten Informationen werden beim Erfassen einer Bestellung als Vorschlagswerte übernommen.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Artikel-Nr.</dt>
<dd>
<p>Artikelnummer gem. <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a></p>
</dd>
<dt>Lieferant</dt>
<dd>
<p>Lieferanten-Adresse</p>
</dd>
<dt>Standardlieferant?</dt>
<dd>
<p>Festlegung des Standardlieferanten. Für die Berechnung des Einstandspreises beim <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikel</a> wird der Eintrag dieses Lieferanten berücksichtigt.</p>
</dd>
<dt>Artikel Lieferant</dt>
<dd>
<p>Artikelnummer und Artikelbezeichnung des Lieferanten</p>
</dd>
<dt>Lieferart</dt>
<dd>
<p>Freies Textfeld für Lieferinformationen</p>
</dd>
<dt>Ursprungslan</dt>
<dd>
<p>Ursprungsland der Artikel, Auswahl aus Tabelle <a class="link" href="ft.refdata.tblland.html" title="Länder">Länder</a></p>
</dd>
<dt>Zahlungsfrist</dt>
<dd>
<p>Zahlungsfrist in Tagen</p>
</dd>
<dt>Mindestmenge</dt>
<dd>
<p>Mindestliefermenge</p>
</dd>
<dt>Farbe</dt>
<dd>
<p>Artikelfarbe</p>
</dd>
<dt>Grösse</dt>
<dd>
<p>Artikel-Grösse</p>
</dd>
<dt>Lieferfristen 1/2</dt>
<dd>
<p>Lieferfrist 1 und 2 in Tagen mit je einem Bemerkungsfeld</p>
</dd>
<dt>Währung</dt>
<dd>
<p>Währungscode gem. Tabelle <a class="link" href="ft.refdata.whgpos.html" title="Währung Umrechnungskurse">Währung Umrechnungskurse</a></p>
</dd>
<dt>Kurs</dt>
<dd>
<p>Umrechnungskurs gem. Tabelle <a class="link" href="ft.refdata.whg.html" title="Währung">Währungen</a></p>
</dd>
<dt>Preisstaffelung</dt>
<dd>
<p>Staffelung nach Listenpreis (Eingabe von 3 Preisen möglich)</p>
</dd>
<dt>L-Preis</dt>
<dd>
<p>Listenpreis</p>
</dd>
<dt>Rabatt</dt>
<dd>
<p>Rabatt auf den Listenpreis in Prozent</p>
</dd>
<dt>Spesen</dt>
<dd>
<p>Spesen / voraussichtliche Zusatzkosten in Prozent zum Listenpreis</p>
</dd>
<dt>E-Preis/Einh</dt>
<dd>
<p>Eistandspreis pro Einheit (L-Preis/Eink. Menge)</p>
</dd>
<dt>Menge</dt>
<dd>
<p>Einkaufsmenge (Erste Zeile: von 0 bis [Menge]; 2. Zeile: von [Menge 1. Zeile] +1 bis [Menge 2. Zeile], etc.)</p>
</dd>
<dt>L-Preis zuk. / ab Datum</dt>
<dd>
<p>Zukünftiger Listenpreis, kann ebenfalls für alle 3 Mengenstaffeln angegeben werden. Ab dem [ab Datum] wird der Preis in den Listenpreis übernommen</p>
</dd>
<dt>Gebinde</dt>
<dd>
<p>Gebindegrösse pro Mengenstaffel (Anzahl Artikel pro Gebinde)</p>
</dd>
<dt>Sktonto</dt>
<dd>
<p>Skonto in Prozent pro Mengenstaffel</p>
</dd>
<dt>Skonto Tg</dt>
<dd>
<p>Skontotage pro Mengenstaffel</p>
</dd>
<dt>Reparaturservice</dt>
<dd>
<p>Reparaturservice, Freies Textfeld für Personinformationen</p>
</dd>
<dt>Sprache Garantie</dt>
<dd>
<p>Garantieschein vorhanden in den Sprachen ..., max. 5 Sprachen können eingegeben werden</p>
</dd>
<dt>Dauer (Monate)</dt>
<dd>
<p>Garantiefrist in Monaten</p>
</dd>
<dt>Sprache Instruktion</dt>
<dd>
<p>Instruktionen (Handbuch) vorhanden in den Sprachen ..., max. 5 Sprachen können eingegeben werden</p>
</dd>
<dt>Rückgabevereinbarungen</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>Verwendete Materialien</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>Rohmaterial</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>Produktion</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>Abfall</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>Dossier</dt>
<dd>
<p>Freies Textfeld</p>
</dd>
<dt>andere V-Kanäle</dt>
<dd>
<p>Codierung für andere Vertriebskanäle, die der Lieferant beliefert. Folgende Codes können eingegeben werden:</p>
</dd>
<dd>
<p>Einzelhandel, Warenhäuser, Versandhandel, Direktverkauf</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalitaät</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.artikel.html" title="Artikel">Artikel</RouteLink></p>
</div></template>


